import React from 'react';

import { ColoredLabel } from './ColoredLabel.styles';

interface BadgeProps {
  color: string;
  children: React.ReactNode;
  className?: string;
  /** Optional max-width override for the badge label (e.g. '20rem'); defaults to 14rem in the styled component. */
  maxWidth?: string;
}

const Badge = ({ color, children, className, maxWidth }: BadgeProps) => {
  return (
    <ColoredLabel $color={color} $maxWidth={maxWidth} className={className}>
      {children}
    </ColoredLabel>
  );
};

export default Badge;
